import { isNumber } from 'src/util/math';

/**
 * Builds the pagination metadata for the provided dataset.
 * @param {Array} items - Array of items to paginate
 * @param {number} currentPage - Current page number (1-based index)
 * @param {number} pageSize - Number of items per page
 * @returns {{itemCount: number, pageCount: number, currentPage: number,
 * pageSize: number, pageStartIndex: number, pageEndIndex: number, paginatedItems: Array,
 * hasNextPage: boolean, hasPreviousPage: boolean}|null} Pagination information,
 * or null if parameters are invalid
 */
const buildPaginationMetadata = (items, currentPage, pageSize) => {
  if (!items || !isNumber(currentPage) || !isNumber(pageSize) || pageSize <= 0) {
    return null;
  }

  const itemCount = items?.length || 0;
  const pageCount = Math.ceil(itemCount / pageSize);
  const pageStartIndex = (currentPage - 1) * pageSize;
  const pageEndIndex = Math.min(pageStartIndex + pageSize, itemCount);
  const paginatedItems = items?.slice(pageStartIndex, pageEndIndex) || [];

  return {
    itemCount,
    pageCount,
    currentPage: Math.max(1, Math.min(currentPage, pageCount || 1)),
    pageSize,
    pageStartIndex,
    pageEndIndex,
    paginatedItems,
    hasNextPage: currentPage < pageCount,
    hasPreviousPage: currentPage > 1,
  };
};

export default buildPaginationMetadata;
